import React, { useRef, useEffect, useState } from "react";

const Research = props => {

  const [state, setState] = useState(0);
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (props.work.focus.research.img.length != 1) {
      timeoutRef.current = setTimeout(() => {
        if (state == (props.work.focus.research.img.length - 1)) {
          setState(0);
        }
        else {
          setState(state => state + 1);
        }
      }, 3000);
    }
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [state]);

  return (
    <>
      <section className="research">
        <div className="info">
          <h1>Research</h1>
          {props.spaceText(props.work.focus.research.content)}
        </div>
        <div className="images">
          <div style={{ backgroundImage: `url(img/projects/${props.work.slug}/focus/${props.work.focus.research.img[state]})` }}>
          </div>
        </div>
      </section>
    </>
  )
}

export default Research;